<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                :value.sync="queryParams.organizationCodeList"
                selectType="selectMultiple"
                :dropdown-match-select-width="false"
                :selectData="inventOrg"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
              <!-- <global-select
                :value.sync="queryParams.organizationCodeList"
                selectType="selectMultiple"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planType: 102 }"
              /> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工单号">
              <global-select
                :value.sync="queryParams.wipEntityIdList"
                selectType="selectMultipleSearch"
                :focusGet="true"
                :selectData="wipEntityIdListData"
                requestApi="/scp/scpMrpWipJobKitting/wipEntityNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ orgList: queryParams.organizationCodeList }"
                searchParam="wipEntityName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划开始时间" :labelCol="{ style: { width: '90px' } }">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.createTimeList, 'YYYY-MM-DD') }}</template>
                <a-range-picker v-model="queryParams.createTimeList" allowClear />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码" v-if="advanced">
              <global-select
                :value.sync="queryParams.itemIdList"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="库存齐套状态" :labelCol="{ style: { width: '90px' } }">
              <global-select
                :value.sync="queryParams.onhandKittingStatus"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MRP_KITTING_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="扩展齐套状态" :labelCol="{ style: { width: '90px' } }">
              <global-select
                :value.sync="queryParams.extendKittingStatus"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MRP_KITTING_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="集采类型">
              <global-select
                :value.sync="queryParams.centralizedPurchasingTypeList"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'MDM_CENTRALIZED_PURCHASING_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form layout="inline" :labelCol="{ style: { width: '120px' } }">
          <a-row class="align-center">
            <download-modal :apiFun="apiScpMrpWipDemandKittingNewExport" ref="download" />
            <a-button type="primary" @click="handleExport" v-hasPermi="['scp:scpMrpWipDemandKitting:export']">导出</a-button>
            <a-col :md="7" :sm="24" class="ml20">
              <a-form-item label="数据收集时间">
                <a-input v-model="dataCollectStartDate" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="齐套分析完成时间">
                <a-input v-model="planCompletionDate" disabled />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="serialNumber"
          :scroll="{ x: tableX, fixScreen: true }"
          @successCallBack="successCallBack"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MATERIAL_SET_REPORT_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text }">
            <div :key="item.dataIndex">
              <span v-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpMrpWipDemandKittingList,
  apiScpMrpWipDemandKittingNewExport,
  apiScpMrpPlansKittingExecutionTime
} from '@/api/scp/workOrderSetCall/materialSetReport'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  name: 'MaterialSetReport',
  components: { DownloadModal },
  data () {
    return {
      apiScpMrpWipDemandKittingNewExport,
      isEdit: false,
      currentId: "",
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpWipDemandKittingList, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        organizationCodeList: undefined,
        wipEntityIdList: undefined,
        createTimeList: undefined,
        staScheduleDate: undefined,
        endScheduleDate: undefined,
        itemIdList: undefined,
        onhandKittingStatus: undefined,
        extendKittingStatus: undefined,
        centralizedPurchasingTypeList: undefined
      },
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 2500,
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center',
          width: 120,
          stickyFixed: 'left',
          ellipsis: true
        },
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          width: 150,
          stickyFixed: 'left',
          ellipsis: true
        },
        {
          title: '计划单号',
          dataIndex: 'orderNo',
          align: 'center',
          width: 150,
          stickyFixed: 'left',
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'primaryUom',
          align: 'center',
          ellipsis: true
        },
        {
          title: '工单总需求',
          dataIndex: 'demandQuantity',
          align: 'center',
          ellipsis: true
        },
        {
          title: '工单已发量',
          dataIndex: 'quantityIssued',
          align: 'center',
          ellipsis: true
        },
        {
          title: '工单未发量',
          dataIndex: 'quantityOpen',
          align: 'center',
          ellipsis: true
        },
        {
          title: '集采类型',
          dataIndex: 'centralizedPurchasingTypeName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '库存分配量',
          dataIndex: 'onhandAssign',
          align: 'center',
          ellipsis: true
        },
        {
          title: '库存欠料量',
          dataIndex: 'onhandShortage',
          align: 'center',
          ellipsis: true
        },
        {
          title: '叫料在途量',
          dataIndex: 'inTransit',
          align: 'center',
          ellipsis: true
        },
        {
          title: '供方库存分配量',
          dataIndex: 'supplierOnhand',
          align: 'center',
          ellipsis: true
        },
        {
          title: '工单供应量',
          dataIndex: 'wipJobSupply',
          align: 'center',
          ellipsis: true
        },
        {
          title: '扩展欠料量',
          dataIndex: 'extendShortage',
          align: 'center',
          ellipsis: true
        },
        {
          title: '库存齐套状态',
          dataIndex: 'onhandKittingStatusName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '扩展齐套状态',
          dataIndex: 'extendKittingStatusName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '备料类型',
          dataIndex: 'deliveryTypeName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '计划开始时间',
          dataIndex: 'scheduleStartDate',
          scopedSlots: { customRender: 'scheduleStartDate' },
          align: 'center',
          width: 170,
          type: "text"
        }
      ],
      dataCollectStartDate: "", // 数据收集时间
      planCompletionDate: "", // 齐套分析完成时间
      wipEntityIdListData: [] // 工单号
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  watch: {
    "queryParams.createTimeList" (newVal, oldVal) {
      this.queryParams.staScheduleDate = newVal && newVal[0] && `${this.$moment(newVal[0]).format('YYYY-MM-DD')} 00:00:00` || ""
      this.queryParams.endScheduleDate = newVal && newVal[1] && `${this.$moment(newVal[1]).format('YYYY-MM-DD')} 23:59:59` || ""
      this.$refs.dataTable.searchParams = this.queryParams;
    },
    // 菜单和工单齐套报表两个入口
    $route (to, from) {
      if (to.name !== "MaterialSetReport") {
        return
      }
      if (Object.keys(this.$route.query).length > 0) {
        this.goNextHandle()
      } else {
        this.$nextTick(() => {
          this.resetQuery()
          this.onSearch()
        })
      }
    }
  },
  created () {
    // 从工单齐套报表页面跳转过来，带过来的数据自动填充
    if (Object.keys(this.$route.query).length > 0) {
      this.goNextHandle()
    } else {
      this.$nextTick(() => {
        this.onSearch()
      })
    }
  },
  mounted () {},
  methods: {
    goNextHandle () {
      const obj = JSON.parse(this.$route.query.data)
      const arr = []
      const arr2 = []
      const arr3 = [{ realValue: "", label: "" }]
      arr.push(String(obj.organizationCode))
      arr2.push(String(obj.wipEntityId))
      this.queryParams.organizationCodeList = obj.organizationCode ? arr : undefined
      this.queryParams.wipEntityIdList = obj.wipEntityId ? arr2 : undefined
      arr3[0].realValue = obj.wipEntityId
      arr3[0].label = obj.wipEntityName
      this.wipEntityIdListData = arr3
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    // 表单搜索
    onSearch () {
      this.getTableTime()
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    successCallBack (myDataSource) {},
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationCodeList: undefined,
        wipEntityIdList: undefined,
        createTimeList: undefined,
        staScheduleDate: undefined,
        endScheduleDate: undefined,
        itemIdList: undefined,
        onhandKittingStatus: undefined,
        extendKittingStatus: undefined,
        centralizedPurchasingTypeList: undefined
      }
      this.tableList = []
      this.$refs.dataTable.myDataSource = []
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('scp/scpMrpWipDemandKitting/export', {
      //   ...this.queryParams
      // }, `工单物料齐套报表_${new Date().getTime()}.xlsx`)
    },
    getTableTime () {
      // 数据收集时间、齐套分析完成时间
      apiScpMrpPlansKittingExecutionTime(this.queryParams).then(res => {
        if (res.data) {
          this.dataCollectStartDate = this.$moment(res.data.dataCollectStartDate).format('YYYY-MM-DD HH:mm:ss')
          this.planCompletionDate = this.$moment(res.data.planCompletionDate).format('YYYY-MM-DD HH:mm:ss')
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.plan-time{
  font-weight: bold;
}
</style>
